'use client'

import { OverlayButton } from '@fukku/button/Overlay/OverlayButton'
import { OverlayButtonVariant } from '@fukku/button/Overlay/types'
import { IconPlusLarge } from 'icons/components/IconPlusLarge'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { dataTestIds } from 'product-card/constants/dataTestIds'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardInteractionContext } from 'product-card/hooks/useProductCardInteractionContext/useProductCardInteractionContext'
import { useCallback } from 'react'
import { cx } from 'utils/cx'

export const iconSize = 16

export function OverlayShowSizesButton({
	className,
}: {
	readonly className?: string
}) {
	const { t } = useLabels()

	const { dataTestId } = useProductCard()
	const { toggleSizePickerVisibility } = useProductCardInteractionContext()

	const handleOnClick = useCallback(() => {
		toggleSizePickerVisibility()
	}, [toggleSizePickerVisibility])

	return (
		<OverlayButton
			className={cx(className)}
			data-testid={dataTestIds.productCardAddToBag(dataTestId)}
			icon={
				<IconPlusLarge
					width={iconSize}
					height={iconSize}
					alt={t('productCard.showSizes.button')}
				/>
			}
			variant={OverlayButtonVariant.IconSmall}
			onClick={handleOnClick}
		/>
	)
}
